import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { Workflow } from '../../models/site-content/workflow.model';
import { WorkflowService } from '../../services/workflow.service';
import { ObjectDetailsBaseComponent } from '../object-details-base/object-details-base';

@Component({
    selector: 'app-workflow-details',
    templateUrl: './workflow-details.component.html',
    styleUrls: ['./workflow-details.component.scss'],
    standalone: false
})
export class WorkflowDetailsComponent extends ObjectDetailsBaseComponent implements OnInit {
    // Properties.
    @Input() workflow: Workflow;

    //@Output() save: EventEmitter<Workflow> = new EventEmitter();
    //@Output() close: EventEmitter<Workflow> = new EventEmitter();

    //private ngFormGroup: FormGroup; // naming it this to avoid confusion with Collect's Forms vs NG's Forms

    // Constructor.
    public constructor(private fbForBaseClass: UntypedFormBuilder, private workflowService: WorkflowService) {
        super(fbForBaseClass, workflowService);

        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        this.setObjectToEdit(this.workflow);
        this.setupFormGroup();
        return;
    }

    // Methods called by my HTML code.
    /*
    public get NgFormGroup(): FormGroup {
        return this.ngFormGroup;
    }

    public get FormInvalid(): boolean {
        return (!this.ngFormGroup.valid);
    }
    */

    // Methods to handle control events.
    /*
    public onSave(): void {
        this.applyEnteredValues();

        this.save.emit(this.workflow);
    }

    public onClose(): void {
        this.close.emit();
    }
    */

    // Helper methods.
    /*
    private setupFormGroup(): void {
        this.ngFormGroup = this.fb.group({
            name: [this.workflow.name, Validators.required],
            description: [this.workflow.description],
            //helpText: [this.form.helpText],
            //helpTextFormat: [this.form.helpTextFormat, Validators.required],
            id: [this.workflow.id],
            dataCollectionId: [this.workflow.dataCollectionId]
        });
    }

    private applyEnteredValues(): void {
        this.workflow.name = this.ngFormGroup.controls.name.value;
        this.workflow.description = this.ngFormGroup.controls.description.value;
    }
    */
}
